import type { AuthStep, OpenedBySources } from '@store/auth';
import SwitchAccountModal from '@components/layout/auth/SwitchAccountModal.vue';

export function useAuth() {
    const gtm = useGtm();
    const authStore = useAuthStore();
    const { loggedIn, userInfo } = classToRefs(authStore);
    const analyticsStore = useAnalyticsStore();
    const route = useRoute();
    const router = useRouter();
    const { isWebApp } = useDevice();
    const { open } = usePopOver({
        component: SwitchAccountModal,
    });
    const openLogin = async (config?: {
        mobile?: string;
        step?: AuthStep;
        message?: string;
        openedBy?: OpenedBySources;
        rejectionText?: string;
        disableSwitchAccount?: boolean;
        permanent?: boolean;
    }) => {
        if (loggedIn.value) {
            return true;
        }
        gtm?.trackEvent({
            event: 'signup-login link',
        });
        const { step, ...attrs } = config || {};
        // Resetting the state
        authStore.error = {};
        authStore.loading = false;
        const LoginModal = await import(
            '@components/layout/auth/LoginModal.vue'
        );
        const { open } = useModal<boolean>({
            component: LoginModal.default,
            attrs: {
                ...attrs,
                initialStep: step,
                fullHeight: true,
                required: config?.permanent,
                disableSwitchAccount: config?.disableSwitchAccount,
            },
            modalAttrs: {
                zIndexFn: () => 2147483647,
                permanent: config?.permanent,
            },
        });
        const result = await open();
        const res = result.args?.[0] || false;
        if (res) {
            useLayoutStore().autoReserveInProcessCount = 0;
            window.WebAppAuthChannel?.postMessage(
                userInfo.value?.userGroup?.toString() ?? ''
            );
        }
        return res;
    };

    const logout = async () => {
        analyticsStore.trackAll('logout_click');
        const { isConfirmed } = await swal({
            icon: 'info',
            text: 'آیا مایلید از حساب خود خارج شوید؟',
            showCancelButton: true,
            cancelButtonText: 'خیر',
            confirmButtonText: 'بله',
        });
        analyticsStore.trackAll('logout_confirmation', {
            confirmed: isConfirmed,
        });
        if (isConfirmed) {
            authStore.logout();
            analyticsStore.trackAll('logOut');
            useLayoutStore().autoReserveInProcessCount = 0;
            if (isWebApp.value) {
                window.WebAppWebEngageChannel?.postMessage(
                    JSON.stringify({
                        type: 'user-logout',
                    })
                );
                window.WebAppAuthChannel?.postMessage('null');
                window.WebAppMetrixAuthChannel?.postMessage('null');
                window.clarity?.('set', 'isLoggedIn', 'false');
                if (localStorage.getItem('app-required-login') === 'true') {
                    await navigateTo({
                        replace: true,
                        path: '/login',
                        query: { from: route.fullPath },
                    });
                }
            } else {
                window.webengage?.user.logout();
            }
            if (route.path.includes('panel')) {
                await router.push('/');
            }
        }
    };
    const switchAccount = () => open();
    return {
        login: openLogin,
        logout,
        switchAccount,
        loggedIn,
    };
}
